import React from "react";
import { Stack, Heading, Text } from "@chakra-ui/layout";
import { useColorModeValue } from "@chakra-ui/color-mode";
import {
    InputGroup,
    Box,
    Input,
    InputRightAddon,
    Link,
    Flex,
    UnorderedList,
    ListItem,
} from "@chakra-ui/react";
import { firebaseClient, getToken } from "firebaseClient";
import { getAccount, updateUser, getAuthUrl } from "../../utils/sessionHelper";
import { CustomSection } from "components/custom-section";
import { useSession } from "next-auth/client";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { Partner } from "./partner";
import { v4 as uuidv4 } from 'uuid';
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { CopyIcon } from '@chakra-ui/icons';

export function Integrations({ }) {

    const [session, loading] = useSession();
    const [refresh, refresher] = React.useState({});
    const isAuthenticated = useFirebaseUser();

    const generateKey = async () => {
        console.log("generateKey");
        let key = uuidv4();
        await updateUser(session, {apiKey: key});
        refresher({});
    }

    React.useEffect(() => {
        if (isAuthenticated && !getAccount(session)?.apiKey) {
            generateKey();
        }
    }, [isAuthenticated, refresh]);

    return (
        <Box>
            <Stack spacing="4">
                <CustomSection
                    title="API Key"
                    description="Use your custom API Key to connect Tweet Hunter with other services"
                    css={{maxW: "600px"}}
                >
                    <Stack padding={4}>
                        <InputGroup size='md' >
                            <Input
                                isDisabled={true}
                                value={getAccount(session)?.apiKey}
                                borderRadius="10px 0px 0px 10px"
                            />
                            <CopyToClipboard
                                text={getAccount(session)?.apiKey}
                                onCopy={() => {
                                    toast.success("Tweet copied to clipboard");
                                }}
                            >
                                <InputRightAddon 
                                    cursor="pointer"
                                    children={<CopyIcon color='green.500' />}
                                />
                            </CopyToClipboard>
                        </InputGroup>
                    </Stack>
                </CustomSection>
                <CustomSection
                    title="Partners"
                    description="Discover amazing products we work with"
                    css={{maxW: "1000px"}}
                >
                    <Stack padding={4}>
                        {
                            [
                                {name:"Taplio", id: "keyTaplio", hasInputKey: true, desc: 
                                    <Box>
                                        <Text>Connect a Taplio account to post on LinkedIn using Tweet Hunter</Text>
                                        {
                                            getAccount(session)?.keyTaplio ? (
                                                <Text fontSize="sm">Congratulations! You’re saving 25% on Tweet Hunter. Save another 25% on Taplio by <Link isExternal href="https://app.taplio.com/settings?tab=integrations">following the same procedure in Taplio.</Link></Text>
                                            ) : (
                                                <Text>Save <Text as={"span"} fontWeight="600" color="green.500">25% on Tweet Hunter </Text> by connecting a Taplio account with an active subscription</Text>
                                            )
                                        }
                                    </Box>
                                , home: "https://app.taplio.com", link: "https://app.taplio.com/settings?tab=integrations", ctaLabel: "Get my API key", image: "https://app.taplio.com/logo/logo_192.png"},
                                {
                                    name: "Zapier",
                                    desc: (
                                      <Box>
                                        <Text>
                                          Connect Tweet Hunter to any other app with Zapier. Triggers available:
                                        </Text>
                                        <UnorderedList ml={10} mt="1">
                                          <ListItem>
                                            <b>Tweet published</b>, let you trigger actions after a tweet has been published like telling your team
                                          </ListItem>
                                        </UnorderedList>
                                      </Box>
                                    ),
                                    home: "https://zapier.com",
                                    link: "https://zapier.com/apps/tweet-hunter/integrations",
                                    image: "/assets/resources/zapier.webp",
                                },
                                // {home: "https://blackmagic.so", image: "https://blackmagic.so/logo.png", name:"Black Magic Sidebar", desc: "Improve your Twitter Growth while staying in Twitter with the Black Magic Chrome Extension. Now get Tweet Hunter AI suggestions directly in Black Magic.", link: "https://blackmagic.so/"},
                            ].map((partner, index) => (
                                <Partner key={index} partner={partner} index={index} />
                            ))
                        }
                    </Stack>
                </CustomSection>
            </Stack>
        </Box>
    );
}
